import flatten from 'lodash/flatten';
import { FETCH_RISK_TOLERANCE, ASSIGN_RISKALYZE_PORTFOLIO } from './RiskToleranceConstants';
import { SET_SELECTED_GROUP_MODEL } from './RiskToleranceActions';

const initialState = {
  selectedGroupId: null,
  selectedModelId: null,
  riskScore: null,
  models: {
    byId: {},
    allIds: [],
  },
  groups: {
    byId: {},
    allIds: [],
  },
  capacity: null,
  composure: null,
  tolerance: null,
};

const riskToleranceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case `${ASSIGN_RISKALYZE_PORTFOLIO}_SUCCESS`: {
      return {
        ...state,
        showRiskalysePopup: false,
        selectedGroupId: payload?.groupId || state.selectedGroupId,
        selectedModelId: payload?.portfolioId || state.selectedModelId,
      };
    }
    case `${FETCH_RISK_TOLERANCE}_SUCCESS`: {
      const payloadModals = payload.items.map(({ modelPortfolios }) => modelPortfolios);
      const allModels = flatten(payloadModals);

      return {
        ...state,
        riskToleranceDisclosure: payload.riskToleranceDisclosure,
        riskalyseProfile: payload.riskalyseProfile,
        selectedGroupId: payload.selectedPortfolioGroupId,
        selectedModelId: payload.selectedPortfolioId,
        riskScore: payload.score,
        showRiskalysePopup: payload.showRiskalysePopup,
        models: {
          byId: allModels.reduce((acc: any, model: any) => ({ ...acc, [model.id]: model }), {}),
          allIds: allModels.map((model: any) => model.id),
        },
        groups: {
          byId: payload.items.reduce((acc, group) => ({ ...acc, [group.groupId]: group }), {}),
          allIds: payload.items.map(({ groupId }) => groupId),
        },
        ...payload,
      };
    }
    case SET_SELECTED_GROUP_MODEL:
      return {
        ...state,
        ...payload,
      };
    default: {
      return state;
    }
  }
};

export default riskToleranceReducer;
